import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import useNetworkRequest from "../../../../hooks/NetworkRequest";
import { ENDPOINTS, urlWithPrefix } from "../../../../configs/APIConfig";
import notify from "../../../../funcs/ToastFuncs";
import LoadingScreen from "../../generic-screens/loading/LoadingScreen";
import { useNavigate } from "react-router-dom";
import StopIcon from '@mui/icons-material/Stop';

function StopTrackingDialog({ open, vehRegNo, closeFunc }) {
  const refreshScreen = () => {
    setTimeout(() => {
      window.location.reload();
    }, 2000); // 2-second delay
  };
  const { fetchData } = useNetworkRequest();
  const abortControllerRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  const navigate = useNavigate();
  const navToErrorScreen = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    navigate("/error", {
      state: {
        releaseProtection: true,
      },
    });
  };

  const stopTracking = async () => {
    setisLoading(true);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const payload = {
      vehicle_number: vehRegNo,
    };
    try {
      const resp = await fetchData({
        url: urlWithPrefix(ENDPOINTS.DASHBOARD.TRACKING.STOP_TRACKING.url),
        method: ENDPOINTS.DASHBOARD.TRACKING.STOP_TRACKING.method,
        authRequired: true,
        timeout: 20000, // 20 Sec timeout
        signal: abortController.signal,
        body: payload,
      });
      if (resp.status === 200) {
        notify("Stopped tracking " + vehRegNo, "success");
        refreshScreen();
      } else {
        setisLoading(false);
        closeFunc();
      }
    } catch (error) {
      console.error("Tracking Details Error", error);
      if (error.code !== "ERR_CANCELED") {
        navToErrorScreen();
      }
      setisLoading(false);
      closeFunc();
    }
    
  };
  return (
    <Dialog open={open} onClose={closeFunc}>
      {!isLoading && (
        <>
          <DialogTitle
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              paddingBottom: "0px !important",
            }}
          >
            <StopIcon
          sx={{
            mr: "5px",
            color:"red"
          }}
        />
            Stop tracking?
          </DialogTitle>
          <Box
            sx={{
              width: "400px",
              padding: "24px",
            }}
          >
            <Typography
              fontSize={"1rem"}
              fontWeight={400}
              sx={{
                opacity: "0.7",
              }}
            >
              Are you sure you want to stop tracking {vehRegNo}?
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
                mt: "20px",
              }}
            >
              <Button
                sx={{
                  fontFamily: "inherit",
                }}
                onClick={closeFunc}
              >
                CANCEL
              </Button>
              <Button
                sx={{
                  fontFamily: "inherit",
                }}
                onClick={stopTracking}
              >
                OK
              </Button>
            </Box>
          </Box>
        </>
      )}
      {isLoading && (
        <Box
          sx={{
            height: "100px",
            width: "400px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            m:"50px 0px"
          }}
        >
          <LoadingScreen containedMode />
        </Box>
      )}
    </Dialog>
  );
}

export default StopTrackingDialog;
